import "./RobotaxiProgressAndBusinessCase.module.css";
import Header from "@/reusable_sections/Header";
import KaffiyehShemaghOversikt from "./sections/KaffiyehShemaghOversikt";
import VideoGalleryRobotaxiInUsa from "./sections/VideoGalleryRobotaxiInUsa";
import TheAdvantage from "./sections/TheAdvantage";
import JoinOurCommunity from "./sections/JoinOurCommunity";
import Footer from "@/reusable_sections/Footer";
export default function RobotaxiProgressAndBusinessCasePage() {
  return <div>
      <Header />
      <KaffiyehShemaghOversikt />
      <VideoGalleryRobotaxiInUsa />
      <TheAdvantage />
      <JoinOurCommunity />
      <Footer />
    </div>;
}